export enum DocumentCategory {
  Payslip = 'payslip',
  TaxReturn = 'tax-return',
  PropertyValue = 'property-value',
  Other = 'other',
}

export enum UploadedByRole {
  MainApplicant = 'main-applicant',
  CoApplicant = 'co-applicant',
}

export type LoanApplicationDocument = {
  CreatedByRole: UploadedByRole;
  ID: string;
  Filename: string;
  Category: DocumentCategory;
  LoanApplicationID: string;
  CreatedAt: string;
  UpdatedAt: string;
  FileID: string;
  UploadedAt?: string;
  Notes?: string;
  UploadURL?: string;
};
